import { isEmptySlateDocument } from "../../../core/constants";
import { countryNameByCode } from "../../../guest-management/forms/constants";
import {
  AddressFields,
  LocationDetails,
  Section,
} from "../../../resources/modelTypes";
import { selectors } from "../../cypressSelectors";
import { ThemedRichText } from "./ThemedRichText";
import { css } from "@emotion/react";
import { SmallHeadline } from "@minted/fancyclothes";
import { theme } from "@minted/minted-components";
import React, { memo } from "react";

const locationStyles = {
  address: css`
    display: flex;
    flex-direction: column;
  `,
  marginTop: css`
    margin-top: ${theme.spacing.x4};
  `,
};

export type DisplayLocationSectionProps = {
  section: Section;
};

export type LocationAddressComponentsProps = {
  addressFields: Partial<AddressFields>;
};
const LocationAddressComponents = memo(
  ({ addressFields }: LocationAddressComponentsProps) => (
    <>
      {addressFields.venue &&
        addressFields.venue !== addressFields.address1 && (
          <div data-cy={`${selectors.sections_collapsedField}_venue`}>
            {addressFields.venue}
          </div>
        )}
      {addressFields.hasPhysicalAddress && (
        <>
          <div
            data-cy={`${selectors.sections_collapsedField}_address1Address2`}
          >
            {addressFields.address1}
            {addressFields.address2 ? `, ${addressFields.address2}` : ""}
          </div>
          <div data-cy={`${selectors.sections_collapsedField}_cityStateZip`}>
            {`${addressFields.city}, ${addressFields.state} ${addressFields.zipCode || ""}`}
          </div>
          {addressFields.country && addressFields.country !== "US" && (
            <div data-cy={`${selectors.sections_collapsedField}_country`}>
              {countryNameByCode[addressFields.country]}
            </div>
          )}
        </>
      )}
    </>
  ),
);

const DisplayLocationSection = ({ section }: DisplayLocationSectionProps) => {
  const details = section.sectionDetails as LocationDetails;

  return (
    <>
      <div css={locationStyles.marginTop}>
        <SmallHeadline>{details.title}</SmallHeadline>
      </div>
      <div>
        <div css={locationStyles.address}>
          <LocationAddressComponents addressFields={details} />
        </div>
      </div>
      {!isEmptySlateDocument(details.content) && (
        <ThemedRichText content={details.content} />
      )}
    </>
  );
};

LocationAddressComponents.displayName = "LocationAddressComponents";

export { LocationAddressComponents };

const MemoizedDisplayLocationSection = memo(DisplayLocationSection);

export { MemoizedDisplayLocationSection as DisplayLocationSection };
